import { DocumentData, DocumentReference } from 'firebase/firestore/lite';
import { SegmentResultFromJson } from 'smartdishpro-scripts/ts_common';
import { toSegmentResultId } from 'src/models/segmentResult';
import { SegmentResult } from 'src/models/segmentResult';

export const toSegmentResultFromDoc = (
  data: DocumentData,
  ref: DocumentReference
): SegmentResult => {
  const _segmentResult = SegmentResultFromJson(data, ref.id);
  return {
    ..._segmentResult,
    id: toSegmentResultId(ref.id),
  };
};
